(function () {
  var bar = document.getElementById('mfp-sticky-atc');
  if (!bar) return;

  var trigger = bar.querySelector('[data-mfp-sticky-atc-trigger]');
  var primaryAddButton = document.querySelector('button[name="add"]');

  function updateVisibility() {
    var y = window.scrollY || window.pageYOffset;
    if (y >= 240) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  if (trigger && primaryAddButton) {
    trigger.addEventListener('click', function () {
      if (primaryAddButton.disabled || primaryAddButton.getAttribute('aria-disabled') === 'true') {
        return;
      }
      primaryAddButton.click();
    });
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);
  updateVisibility();
})();
